import React, { ReactElement } from "react";
import Text from "@components/shared/text";
import Image from "next/legacy/image";
import styles from "./style.module.scss";
import Breadcrumb from "@components/shared/breadcrumb";
import { translate } from "@helpers/translationObjectFormatter";
import { TranslationsObject } from "@genericTypes/sharedTypes";
import { useQuery } from "@tanstack/react-query";
import Form from "./form";

export default function ContactUS(): ReactElement {
    const { data: translations } = useQuery<TranslationsObject>([
        "translations",
    ]);
    const arr = [
        {
            label: translate(translations, "several_general_breadcrumb_home"),
            link: "/",
            isActive: true,
            showOnMobile: true,
        },

        {
            label: translate(translations, "several_contactUS_mainTitle"),
            link: "",
            isActive: false,
            showOnMobile: true,
        },
    ];
    return (
        <div className={`${styles["beforeStyle"]} -mt-4`}>
            <div className="pt-4">
                <Breadcrumb arr={arr} />
                <Text
                    type="title"
                    className="lg:text-4xl lg:leading-[63px] font-bold text-center mt-4"
                >
                    {translate(translations, "several_contactUS_mainTitle")}
                </Text>
                <Text className="lg:text-lg lg:leading-9 text-center px-1">
                    {translate(
                        translations,
                        "several_contactUS_mainDescription",
                    )}
                </Text>
                <div className="flex lg:flex-row flex-col  items-center ">
                    <Form />
                    <div className="relative lg:w-1/2 w-[75%] max-w-[575px]  sm:w-[420px] sm:h-[500px] lg:min-h-[640px] h-[300px] lg:top-44   ">
                        <Image
                            src="/contact-us/contactusimg.png"
                            alt="contact us"
                            layout="fill"
                            // width={500}
                            // height={568}
                        />
                    </div>
                </div>
            </div>
        </div>
    );
}
